// extracted by mini-css-extract-plugin
export default {"zoomModal":"B3-z"};